<template>
  <div
    class="i-base-tab"
    :style="{ '--bg-color': props.bgColor, '--tab-color': props.activeTabColor }"
  >
    <div
      v-for="tab in props.tabs"
      :key="tab.id"
      class="tab"
      :class="{ active: tab.id === props.activeTab }"
      @click="changeTab(tab.id)"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { black100, white } from "@/styles/colors"

// Props
const props = defineProps({
  tabs: Array as () => { id: number; name: string }[],
  activeTab: Number,
  bgColor: {
    type: String,
    default: black100
  },
  activeTabColor: {
    type: String,
    default: white
  }
})

// Functions
const emit = defineEmits(["setActiveTab"])

function changeTab(id: number) {
  emit("setActiveTab", id)
}
</script>

<style scoped lang="scss">
.i-base-tab {
  @include border-radius-md;
  @include text-xs;

  background-color: var(--bg-color);
  color: $comet500;
  display: flex;
  font-weight: bold;
  padding: 3px;

  .tab {
    min-height: 32px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
  }

  .tab:hover {
    color: black;
  }

  .tab.active {
    @include border-radius-sm;

    background-color: var(--tab-color);
    color: black;
  }
}
</style>
